import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { BuySellService } from '@app/modules/time-off/services/buy-sell.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-buy-sell-approve-deny-dialog',
  templateUrl: './buy-sell-approve-deny-dialog.component.html',
  styleUrls: ['./buy-sell-approve-deny-dialog.component.scss']
})
export class BuySellApproveDenyDialogComponent implements OnInit {
  type: string; // 'buy' or 'sell'
  action: string; // 'approve' or 'deny'
  message: string;
  comments: string = '';
  buySellApprovalId: string;

  constructor(
    private buySellService: BuySellService,
    private overlayService: OverlayService,
    private snackbarService: SnackbarService,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<BuySellApproveDenyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.buySellApprovalId = data.buySellApprovalId;
    this.type = data.type;
    this.action = data.action;
    this.message = data.message;
  }
  ngOnInit(): void {
  }

  save(): void {
    this.overlayService.show();

    const commentsObj = {
      comments: this.comments
    }

    if(this.action === 'approve') {
      this.buySellService.approveBuySellApproval(this.buySellApprovalId, commentsObj).subscribe({
        next: () => {
          this.snackbarService.openSnackBar(`${this.translate.instant('SavedSuccessfully')}`, 'clear', 'success');
          this.overlayService.hide();
          this.dialogRef.close(true);
        },
        error: (err) => {
          console.error('Error approving request:', err);
          this.overlayService.hide();
        }
      });
    }
    else if(this.action === 'deny') {
      this.buySellService.denyBuySellApproval(this.buySellApprovalId, commentsObj).subscribe({
        next: () => {
          this.snackbarService.openSnackBar(`${this.translate.instant('SavedSuccessfully')}`, 'clear', 'success');
          this.overlayService.hide();
          this.dialogRef.close(true);
        },
        error: (err) => {
          console.error('Error denying request:', err);
          this.overlayService.hide();
        }
      });
    }
  }

  close(): void {
    this.dialogRef.close();
    // Close the dialog
  }

}
